import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';

import '../../style/SignupForm.css';

const TermsAndConditionsCheckbox = ({ handleCheckboxValue, errors }) => {
  const { t } = useTranslation();

  const landingUrl = 'https://cigotracker.com';
  const privacyUrl = `${landingUrl}/public/privacy-policy/`;
  const tosUrl = `${landingUrl}/public/terms-of-use-internal-end-users/`;

  return (
    <FormGroup>
      <FormControlLabel
        required
        control={
          <Checkbox
            name="acceptTos"
            onChange={handleCheckboxValue}
            onBlur={handleCheckboxValue}
            error={errors}
          />
        }
        label={
          <label>
            {t("terms_1")}&nbsp;
            <Link href={tosUrl} underline="none" target="_blank">{t("terms_2")}</Link>
            &nbsp;{t("terms_3")}&nbsp;
            <Link href={privacyUrl} underline="none" target="_blank">{t("terms_4")}</Link>.
          </label>
        }
      />
    </FormGroup>
  );
};

export default TermsAndConditionsCheckbox;